<template>
	<div class="row">
		<div class="col-12">
			
			<card  title="Search">
				<template slot="command">
					<!--<p-button :disabled="appointments.length<1 || loading" round class="btn btn-success" @click.native.prevent="excel_export">Export to Excel</p-button>-->
					<p-button v-if="appointments.length>0 && !loading" round class="btn btn-success" @click.native.prevent="print">Print</p-button>
				</template>
				<div class="row mb-3">
					<div class="col-xl-3">
						<label>Client Name</label>
						<input type="text" class="form-control" placeholder="Client Name" v-model="filter.client_name">
					</div>
					<div class="col-xl-3">
						<label>Client Surname</label>
						<input type="text" class="form-control" placeholder="Client Surname" v-model="filter.client_surname">
					</div>
					<div class="col-xl-2">
						<label>Job Num.</label>
						<input type="text" class="form-control" placeholder="Job Num." v-model="filter.job_num">
					</div>
                    <div class="col-xl-2 col-lg-2 align-self-end">
                       <p-button v-if="canSearch" :loading="loading" round class="btn btn-success" @click.native.prevent="loadAppointments()">Search</p-button>
                    </div>

				</div>
				<div class="row" id="print">
					<div class="col-12">
						<b-table responsive small hover :items="appointments" :fields="columns" :busy='loading' show-empty>
							<template v-slot:table-busy>
								<loader :loading="loading"></loader>
							</template>
							<template v-slot:cell(options)="row">
								<router-link :to="'/dashboard/'+row.item.id_employee+'/'+row.item.date+'?app='+row.item.id_appointment"><p-button size="sm" round class="btn btn-success">Edit</p-button></router-link>
							</template>
						</b-table>
					</div>
				</div>
			</card>
		</div>
	
	</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import XLSX from 'xlsx';

export default {
	components: {
		Datepicker
	},
	data(){
		return {
			loading:false,
			filter:{
				client_name:null,
				client_surname:null,
				job_num:null
			},
			appointments:[],
			columns: [
				{
					key: "id_appointment",
					label: "#"
				},
				{
					key:'reference',
					label:'Reference'
				},
				{
					key: "date",
                    label: "Date",
                    formatter:(value)=>{
                        return this.$moment(value).format('DD/MM/YYYY')
                    }
				},
				{
					key: "employee",
					label: "Employee",
					formatter:(value)=>{
						return value.first_name+' '+value.last_name
					}
				},
				{
					key: "client",
					label: "Client",
					formatter:(value)=>{
						let client = value.first_name;
						if(value.last_name!==null){
							client+=' '+value.last_name
						}
						return client
					}
				},
				{
					key: "detail",
					label: "Detail"
				},
				{
					key:"note",
					label:"Note"
				},
				{
					key:"options",
					label:"",
					class:'text-right'
				}
			]
		}
	},
	computed:{
		canSearch(){
			return (this.filter.client_name!=null && this.filter.client_name!='')
			|| 
			(this.filter.client_surname!=null && this.filter.client_surname!='')
			||
			(this.filter.job_num!=null && this.filter.job_num!='')
		}
	},
	methods:{
		myRowClickHandler(record, index){
			this.$router.push('/dashboard/'+record.id_employee+'/'+record.date+'?app='+record.id_appointment);

		},
		async loadAppointments(){
            this.loading = true;

            let where = '';
            if(this.filter!==null && this.filter!==''){
				/*if(!isNaN(this.filter)){
					where += this.filter+'/0';
				}
				else{
					where += '0/'+this.filter;
				}*/
				let source = 'appointment/s/report-search?';
				if(this.filter.client_name!=null && this.filter.client_name!=''){
					source+='first_name='+this.filter.client_name+'&'
				}
				if(this.filter.client_surname!=null && this.filter.client_surname!=''){
					source+='last_name='+this.filter.client_surname+'&'
				}
				if(this.filter.job_num!=null && this.filter.job_num!=''){
					source+='id_appointment='+this.filter.job_num+'&'
				}
				let result = await this.$api.get(source);
				this.appointments = result.data;
			}
			
			this.loading = false;
		},
		print(){
			this.$print({
				header: '<h3 class="custom-h3">Report on filter: "'+this.filter+'"</h3>',
				printable: this.appointments.map(a=>{
					return{
						id_appointment:a.id_appointment,
						reference:a.reference ? a.reference : '',
						date:this.$moment(a.date).format('DD/MM/YYYY'),
						employee:a.employee.first_name+' '+a.employee.last_name,
						client:a.client.first_name+' '+a.client.last_name
					}
				}), 
				properties: [
					{field:'id_appointment',displayName:'#'},
					{field:'reference',displayName:'Reference'},
					{field:'date',displayName:'Date'}, 
					{field:"employee",displayName:'Employee'}, 
					{field:"client",displayName:'Client'},
				], 
				type: 'json'
			});
        }
	}
}
</script>

<style>
</style>
